export default function DayByDayProgram() {
  const programDays = [
    {
      day: 'TAG 1',
      title: 'ANKUNFT & LUXUS-ERLEBNIS',
      color: 'from-blue-500 to-blue-600',
      activities: [
        {
          time: '15:00 Uhr',
          title: 'Welcome & Check-In',
          description: 'Ankunft im luxuriösen 5-Sterne-City-Hotel. Persönlicher Empfang, Hilfe beim Check-In und erste Orientierung im Hotel.'
        },
        {
          time: '15:30 Uhr',
          title: 'Welcome Drink & Kennenlernen',
          description: 'Exklusive Begrüßung in der Hotel-Lobby Lounge. Networking und Vorstellungsrunde der Teilnehmer.'
        },
        {
          time: '17:00 Uhr',
          title: 'Private Sunset Yacht Experience',
          description: 'Abfahrt vom Dubai Marina. 2-stündige Yachtfahrt entlang JBR, Bluewaters Island und Palm Jumeirah. Goldener Sonnenuntergang mit Fotomomenten und entspanntem Networking.'
        },
        {
          time: '20:00 Uhr',
          title: 'Dinner',
          description: 'Gemeinsames Abendessen in einem ausgewählten Fine-Dining-Restaurant in Dubai.'
        }
      ]
    },
    {
      day: 'TAG 2',
      title: 'BUSINESS-TAG IM BURJ AL ARAB',
      color: 'from-indigo-500 to-indigo-600',
      activities: [
        {
          time: '09:00 – 16:00 Uhr',
          title: 'Dubai Masterclass im Burj Al Arab',
          description: 'Exklusiver Konferenzraum im legendären 7-Sterne-Hotel mit atemberaubendem Meerblick.',
          details: [
            'Vergangenheit: Vom Wüstenhandel zur Weltmetropole',
            'Gegenwart: Das Ökosystem für internationale Investoren',
            'Immobilienmarkt: Off-Plan vs. Ready Properties (Deep Dive)',
            'Firmen & Freezones: Banking, Gründungen in allen 7 Emiraten',
            'GCC-Länder: Saudi-Arabien, Katar, Bahrain, Oman, Kuwait',
            'Crypto, Compliance & Regulierung',
            'Gastredner mit 25 Jahren Dubai-Erfahrung'
          ],
          highlight: 'Inklusive: Luxus-Frühstück & Mittagssnack im Burj Al Arab',
          images: [
            {
              url: 'https://public.readdy.ai/ai/img_res/d0c115945af3b8e971f2dccd09007ba2.jpg',
              alt: 'Seminarraum im Burj Al Arab'
            },
            {
              url: 'https://readdy.ai/api/search-image?query=Iconic%20Burj%20Al%20Arab%20hotel%20exterior%20view%20from%20beach%2C%20famous%20sail-shaped%20luxury%207-star%20hotel%20in%20Dubai%2C%20stunning%20architecture%20against%20blue%20sky%2C%20Arabian%20Gulf%20waters%2C%20golden%20hour%20lighting%2C%20architectural%20masterpiece%2C%20world-renowned%20landmark%20building&width=800&height=500&seq=burj-al-arab-exterior&orientation=landscape',
              alt: 'Burj Al Arab Außenansicht'
            }
          ],
          link: {
            text: 'Zur detaillierten Masterclass',
            url: '/masterclass'
          }
        },
        {
          time: '20:00 Uhr',
          title: 'Dinner im Atlantis The Royal',
          description: 'Fine-Dining Abendessen in einem der exklusivsten Resorts des Mittleren Ostens.'
        }
      ]
    },
    {
      day: 'TAG 3',
      title: 'CITY INVESTMENT TOUR & NETWORKING',
      color: 'from-purple-500 to-purple-600',
      activities: [
        {
          time: '09:00 Uhr',
          title: 'Breakfast Event im Hotel',
          description: 'Networking-Frühstück, Vorstellung der Tagesagenda.'
        },
        {
          time: '10:30 Uhr',
          title: 'Investment City Tour',
          description: 'Geführte Tour durch bedeutende Wirtschafts- und Investitionsstandorte:',
          topics: [
            'Top Freezones in Dubai',
            'Erfolgreiche Immobilienprojekte',
            'Büroturm-Besichtigungen',
            'Zukunftsprojekte (Creek Harbour, Dubai South, Expo City)'
          ]
        },
        {
          time: '12:30 Uhr',
          title: 'Snack-Pause',
          description: 'Leichter Business-Lunch unterwegs.'
        },
        {
          time: '20:00 Uhr',
          title: 'Dinner in Dubai',
          description: 'Gemeinsames Abendessen im ausgewählten Restaurant.'
        }
      ]
    },
    {
      day: 'TAG 4',
      title: 'FREEZONE-TAG & DESERT DINNER',
      color: 'from-teal-500 to-teal-600',
      activities: [
        {
          time: '09:00 Uhr',
          title: 'Fahrt in den Norden der VAE',
          description: 'Ganztägige Tour in mehrere Emirate.'
        },
        {
          time: '10:30 Uhr',
          title: 'Umm Al Quwain Freezone',
          description: 'Einblick in Unternehmensgründungen, Lizenzmodelle und steuerliche Vorteile.'
        },
        {
          time: '13:00 Uhr',
          title: 'Ajman Immobilien & Freezone',
          description: 'Besichtigung lokaler Immobilien-Hotspots und Unternehmensmöglichkeiten.'
        },
        {
          time: '15:30 Uhr',
          title: 'Ras Al Khaimah Freezone & Immobilien',
          description: 'Premium-Besichtigungen und Erklärungen zu zukunftsstarken Projekten.'
        },
        {
          time: '18:30 Uhr',
          title: 'Desert Dinner in Ras Al Khaimah',
          description: 'Traditionelles Wüstencamp mit luxuriösem BBQ, Sundowner und Entertainment.'
        },
        {
          time: '22:30 Uhr',
          title: 'Rooftop-Ausklang in Dubai',
          description: 'Rückfahrt und entspanntes Networking auf einer Rooftop-Bar mit Blick auf Downtown Dubai.'
        }
      ]
    },
    {
      day: 'TAG 5',
      title: 'EXKLUSIVE EINZELGESPRÄCHE',
      color: 'from-emerald-500 to-emerald-600',
      activities: [
        {
          time: '09:00 Uhr',
          title: 'Individuelle Investorengespräche',
          description: '1-zu-1 Termine mit Experten:',
          topics: [
            'Immobilien & Projektberatung',
            'Unternehmensgründung / Freezones',
            'Steueroptimierung',
            'Persönliche Strategien & Portfolioanalyse'
          ]
        },
        {
          time: 'Flexibel',
          title: 'Abreise',
          description: 'Flexible Abreise der Teilnehmer.'
        }
      ]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Detailliertes <span className="text-blue-600">5-Tage-Programm</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Jeden Tag erwarten Sie neue Erlebnisse, wertvolle Kontakte und exklusive Einblicke in die Investmentmöglichkeiten von Dubai.
          </p>
        </div>

        <div className="space-y-12">
          {programDays.map((day, dayIndex) => (
            <div key={dayIndex} className="bg-gray-50 rounded-3xl p-8 md:p-12 shadow-lg">
              {/* Day Header */}
              <div className={`bg-gradient-to-r ${day.color} rounded-2xl p-6 mb-8 text-white text-center`}>
                <h3 className="text-2xl md:text-3xl font-bold mb-2">{day.day}</h3>
                <p className="text-lg md:text-xl font-medium">{day.title}</p>
              </div>

              {/* Activities */}
              <div className="space-y-6">
                {day.activities.map((activity, activityIndex) => (
                  <div key={activityIndex} className="bg-white rounded-xl p-6 shadow-md border-l-4 border-blue-500">
                    <div className="flex flex-col md:flex-row md:items-start gap-4">
                      <div className="bg-blue-50 rounded-lg px-4 py-2 text-blue-700 font-bold text-sm whitespace-nowrap">
                        {activity.time}
                      </div>
                      <div className="flex-1">
                        <h4 className="text-xl font-bold text-gray-900 mb-3">{activity.title}</h4>
                        <p className="text-gray-600 leading-relaxed mb-4">{activity.description}</p>
                        
                        {activity.topics && (
                          <div className="bg-blue-50 rounded-lg p-4 mb-4">
                            <h5 className="font-bold text-blue-700 mb-2">Programmpunkte:</h5>
                            <ul className="space-y-1">
                              {activity.topics.map((topic, topicIndex) => (
                                <li key={topicIndex} className="text-gray-700 flex items-center">
                                  <i className="ri-check-line text-blue-600 mr-2"></i>
                                  {topic}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                        
                        {activity.images && (
                          <div className="grid md:grid-cols-2 gap-4 mb-4">
                            {activity.images.map((image, imageIndex) => (
                              <div key={imageIndex} className="relative">
                                <img 
                                  src={image.url}
                                  alt={image.alt}
                                  className="w-full h-64 object-cover rounded-lg shadow-md"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 rounded-b-lg">
                                  <p className="text-white text-sm font-medium">{image.alt}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                        
                        {activity.note && (
                          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-3 rounded">
                            <p className="text-yellow-800 font-medium text-sm">{activity.note}</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}